// index.js
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// MUI v5 kullanıyorsan:
// import { withStyles } from '@mui/styles';

import SwaggerUI from './Swagger';
import InfoContent from './Info';
import * as types from '../../../redux/constants';
import styles from './style';

const Content = (props) => {
  const { classes, products } = props;
  const { contentType, infoContent, swaggerContent, productList } = products;

  const isInfo = contentType === types.DocsMainContentType.INFO;

  return (
    <main className={classes.content}>
      {isInfo ? (
        <div className={classes.infoWrapper}>
          <InfoContent
            classes={classes}
            infoContent={infoContent}
            productList={productList}
          />
        </div>
      ) : (
        <div className={classes.swaggerWrapper}>
          <SwaggerUI classes={classes} url={swaggerContent} />
        </div>
      )}
    </main>
  );
};

Content.propTypes = {
  classes: PropTypes.object.isRequired,
  products: PropTypes.shape({
    contentType: PropTypes.any,
    infoContent: PropTypes.any,
    swaggerContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    productList: PropTypes.array,
  }).isRequired,
};

export default withStyles(styles)(Content);
